import { useParams } from 'js/lib/useRouter';

import GoogleCertificateEpicClient from 'bundles/epic/clients/GoogleCertificate';

const SIMPLIFIED_PAGE_SLUGS = [
  'data-analytics-certificate',
  'project-management-certificate',
  'cybersecurity-certificate',
  'digital-marketing-certificate',
  'it-support-certificate',
  'ux-design-certificate',
];

const useIsSimplifiedGoogleXdp = () => {
  const { productSlug } = useParams();

  if (SIMPLIFIED_PAGE_SLUGS.includes(productSlug) && GoogleCertificateEpicClient.get('enableSimplifiedGoogleXdp')) {
    return true;
  }

  return false;
};

export default useIsSimplifiedGoogleXdp;
